const darkTheme = {
  background: "#283149",
  textPrimary: "#dbedf3",
  textSecundary: "gray",
  primary: "#00818a",
  secundary: "#404b69",
};

export default darkTheme;
